import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../../components/HOC/injectRole'

import { TRoutes } from '../../../shared/const'
import { mayOpenAdminPage } from '../../../shared/alumni'
import Invoices from '../../../components/views/admin/Invoices'

function InvoicesPage(props) {
	if (mayOpenAdminPage(props.role, 'invoices')) return <Invoices />
	else return <Redirect to={TRoutes.DASHBOARD} />
}

InvoicesPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(InvoicesPage)
